import { Form } from "react-bootstrap";

export interface FormLabelTextProps {
    label: string;
    text1: string;
    text2?: string;
    text3?: string;
}
export function FormLabelText(props: FormLabelTextProps) {
    return (
        <>
            <div>
                <Form.Label className="m-0">{props.label}</Form.Label>
            </div>
            <div>
                <Form.Text>{props.text1} </Form.Text>
                {props.text2 &&
                    <Form.Text>{props.text2} </Form.Text>
                }
                {props.text3 &&
                    <Form.Text>{props.text3} </Form.Text>
                }
            </div>
        </>
    )
}
